import { apiClient } from "@api/client";
import { request } from "@api/request";
import { toTodayVisit, type TodayVisit } from "@visits/visitsClient";

export const calendarClient = {
  /**
   * Visits scheduled within an inclusive clinic-local date range, in the same
   * shape as `/visits/today` (patient/owner/provider names + current stage).
   */
  range: (start: string, end: string): Promise<TodayVisit[]> =>
    request(() =>
      apiClient.GET("/visits/scheduled", {
        params: { query: { start, end } },
      }),
    ).then((rows) => rows.map(toTodayVisit)),
};
